var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('img',{attrs:{"src":'static/image/' + _vm.myLittleimg + '.jpg',"width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"word-title"},[_vm._v(_vm._s(_vm.Suppliers[0]))]),_vm._v(" "),_c('span',{staticClass:"word-title1"},[_vm._v(_vm._s(_vm.Suppliers[1]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1fb3d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/top-image/top-little-image.vue
// module id = null
// module chunks = 